import React, { type FunctionComponent } from 'react'
import { Box } from 'legacy/dash-blocks/box/Box'
import { type OrderType } from 'legacy/sections/orders/utils/orders.types'
import {
  parseDateAndTimeFromDeliveryOption,
  parseDateAndTimeFromEta,
} from 'legacy/sections/orders/components/list/components/table/components/eta-cell/utils/OrdersListTableEtaCell.utils'

interface Props {
  eta: string | null
  deliveryOption: string | null
  orderType: OrderType
}

export const OrdersListTableEtaCell: FunctionComponent<Props> = ({
  eta,
  deliveryOption,
  orderType,
}) => {
  const { dateStr, timeStr } =
    orderType === 'pickup' && deliveryOption !== 'PickupEta'
      ? parseDateAndTimeFromDeliveryOption(deliveryOption || '')
      : parseDateAndTimeFromEta(eta || '')

  return (
    <Box>
      {dateStr && (
        <Box testId="eta-cell-date" marginBottom="xxsmall">
          {dateStr}
        </Box>
      )}
      <Box testId="eta-cell-time">{timeStr}</Box>
    </Box>
  )
}
